import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showModal, showSpinner } from "./../Slices/sessionSlice";
import { newAlert } from "./../Slices/alertSlice";
import Axios from "./../axios";
import { updateCandidateData } from "./orgAdminSlice";

// #region Create User
export const createUser = createAsyncThunk(
  "admin/createUser",
  async (payload, thunkAPI) => {
    try {
      const { data } = await Axios.post(`/api/admin/create-user`, payload);
      if (!data.isUserCreated) {
        thunkAPI.dispatch(
          newAlert({
            type: "danger",
            message: data.error,
          })
        );
      } else {
        thunkAPI.dispatch(
          newAlert({
            type: "success",
            message: "User Created Successfully",
          })
        );
      }
      thunkAPI.dispatch(showSpinner(null));
      thunkAPI.dispatch(showModal(null));
      return data;
    } catch (err) {
      thunkAPI.dispatch(showSpinner(null));
      thunkAPI.dispatch(
        newAlert({
          type: "danger",
          message: err.message,
        })
      );
      console.error("Error in create user :- ", err.message);
      return Promise.reject(err);
    }
  }
);
// #endregion

// #region Edit Candidate
export const editCandidate = createAsyncThunk(
  "admin/editCandidate",
  async (payload, thunkAPI) => {
    try {
      const { data } = await Axios.put(`/api/generic/edit-candidate`, payload);
      if (!data.isCandidateEdited) {
        return thunkAPI.dispatch(
          newAlert({
            type: "danger",
            message: data.error,
          })
        );
      } else {
        thunkAPI.dispatch(
          newAlert({
            type: "success",
            message: "User Data Changed Successfully",
          })
        );
        thunkAPI.dispatch(
          getCandidates({
            organizationId: payload.organizationId,
            filterBy: "Candidate",
          })
        );
      }
      thunkAPI.dispatch(showSpinner(null));
      thunkAPI.dispatch(showModal(null));
      return payload;
    } catch (err) {
      thunkAPI.dispatch(showSpinner(null));
      thunkAPI.dispatch(
        newAlert({
          type: "danger",
          message: err.message,
        })
      );
      console.error("Error in edit user :- ", err.message);
      return Promise.reject(err);
    }
  }
);
// #endregion

// #region Get Candidates
export const getCandidates = createAsyncThunk(
  "admin/getCandidates",
  async (payload, thunkAPI) => {
    try {
      let { organizationId, filterBy } = payload;
      const { data } = await Axios.get(
        `/api/admin/get-candidates/${organizationId}?filterBy=${filterBy}`
      );
      return data.candidates;
    } catch (err) {
      thunkAPI.dispatch(
        newAlert({
          type: "danger",
          message: err.message,
        })
      );
      console.error("Error in get Candidate :- ", err.message);
      return Promise.reject(err);
    }
  }
);
// #endregion

// #region Remove Candidate
export const removeCandidate = createAsyncThunk(
  "admin/removeCandidates",
  async (payload, thunkAPI) => {
    try {
      console.log(payload, "payload");
      const { data } = await Axios.put(`/api/admin/remove-candidate`, payload);
      if (!data.isUserRemoved) {
        return thunkAPI.dispatch(
          newAlert({
            type: "danger",
            message: data.error,
          })
        );
      } else {
        thunkAPI.dispatch(
          newAlert({
            type: "success",
            message: "Candidate Removed",
          })
        );
      }
      thunkAPI.dispatch(showSpinner(null));
      thunkAPI.dispatch(showModal(null));
      return data.candidateId;
    } catch (err) {
      thunkAPI.dispatch(showSpinner(null));
      thunkAPI.dispatch(
        newAlert({
          type: "danger",
          message: err.message,
        })
      );
      console.error("Error in get Candidate :- ", err.message);
      return Promise.reject(err);
    }
  }
);
// #endregion

export const adminSlice = createSlice({
  name: "admin",
  initialState: {
    candidates: [],
  },
  reducers: {},
  extraReducers: {
    //#region getCandidates
    [getCandidates.fulfilled]: (state, { payload }) => {
      state.candidates = payload;
    },
    [getCandidates.rejected]: (state) => {},
    [getCandidates.pending]: (state) => {},
    //#endregion

    //#region removeCandidate
    [removeCandidate.fulfilled]: (state, { payload }) => {
      const updatedCandidates = state.candidates.filter(
        (candidate) => candidate._id !== payload
      );
      state.candidates = updatedCandidates;
    },
    [removeCandidate.rejected]: (state) => {},
    [removeCandidate.pending]: (state) => {},
    //#endregion

    //#region removeCandidate
    [editCandidate.fulfilled]: (state, { payload }) => {
      const updatedCandidates = state.candidates.map((candidate) => {
        if (candidate._id === payload.candidateId) {
          return {
            ...candidate,
          };
        }
        return candidate;
      });
      state.candidates = updatedCandidates;
    },
    [editCandidate.rejected]: (state) => {},
    [editCandidate.pending]: (state) => {},
    //#endregion
  },
});

// Export Actions
// export const { } = adminSlice.actions;

// Export Reducer
export default adminSlice.reducer;
